export * from '@primeuix/themes/aura/badge';
export { default } from '@primeuix/themes/aura/badge';
